<template>
  <div class="lp-collapse">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'lp-collapse',
})
</script>
